import dayjs from 'dayjs'
require('dayjs/locale/zh-cn')
dayjs.locale('zh-cn')

// 日期段转时间段 开始时间以00:00:00结尾，结束时间以23:59:59结尾
const dateRangeToTimeRange = (dateRange, formater = 'YYYY-MM-DD') => {
  let [startDate, endDate] = dateRange
  startDate = dayjs(new Date(startDate))
  endDate = dayjs(new Date(endDate))
  if (startDate.isValid() && endDate.isValid()) {
    const startTime = dayjs().startOf('day').format('HH:mm:ss')
    const endTime = dayjs().endOf('day').format('HH:mm:ss')
    startDate = startDate.format(formater)
    endDate = endDate.format(formater)
    startDate = `${startDate} ${startTime}`
    endDate = `${endDate} ${endTime}`
    return [startDate, endDate]
  }
  return dateRange
}

// 获取之前/之后时间
const getAddRange = (
  number,
  String = 'day',
  date = new Date(),
  formater = 'YYYY-MM-DD'
) => {
  let calDate = dayjs(date).add(number, String).format(formater)
  date = dayjs(date).format(formater)
  return dayjs(calDate).isBefore(date) ? [calDate, date] : [date, calDate]
}

// 精确至date时间段显示
const formateDateRange = (start, end = new Date()) => {
  start = dayjs(start)
  end = dayjs(end)
  if (start.isValid() && end.isValid()) {
    const startObj = calRelativeDate(start)
    const endObj = calRelativeDate(end, start)
    let startStr, endStr
    if (startObj) {
      startStr = `${startObj.year ? startObj.year + '年' : ''}${
        start.month() + 1
      }月${start.date()}日`
    }
    if (endObj) {
      endStr = `${endObj.year ? endObj.year + '年' : ''}${
        endObj.month ? endObj.month + '月' : ''
      }${endObj.date ? endObj.date + '日' : ''}`
    }
    return endStr ? `${startStr}~${endStr}` : startStr
  } else {
    return ''
  }
}
// 精确至month时间段显示
const formateMonthRange = (start, end = new Date()) => {
  start = dayjs(start)
  end = dayjs(end)
  if (start.isValid() && end.isValid()) {
    const startObj = calRelativeDate(start)
    const endObj = calRelativeDate(end, start)
    let startStr, endStr
    if (startObj) {
      startStr = `${startObj.year ? startObj.year + '年' : ''}${
        start.month() + 1
      }月`
    }
    if (endObj) {
      endStr = `${endObj.year ? endObj.year + '年' : ''}${
        endObj.month ? endObj.month + '月' : ''
      }`
    }
    return endStr ? `${startStr}~${endStr}` : startStr
  } else {
    return ''
  }
}
// 精确至上下旬时间段显示
const formatePeriodRange = (start, end = new Date()) => {
  start = dayjs(start)
  end = dayjs(end)
  if (start.isValid() && end.isValid()) {
    const startObj = calRelativeDate(start)
    const endObj = calRelativeDate(end, start)
    let startStr, endStr
    if (startObj) {
      startStr = `${startObj.year ? startObj.year + '年' : ''}${
        start.month() + 1
      }月${start.date() <= 6 ? '上旬' : '下旬'}`
    }
    if (endObj) {
      endStr = `${endObj.year ? endObj.year + '年' : ''}${
        endObj.month ? endObj.month + '月' : ''
      }${endObj.date ? (endObj <= 6 ? '上旬' : '下旬') : ''}`
    }
    return endStr ? `${startStr}~${endStr}` : startStr
  } else {
    return ''
  }
}

const calRelativeDate = (date, baseDate = new Date()) => {
  date = dayjs(date)
  baseDate = dayjs(baseDate)
  if (date.isValid() && baseDate.isValid()) {
    let y = date.year()
    let m = date.month()
    let d = date.date()
    return {
      year: y == dayjs(baseDate).year() ? '' : y,
      month: m == dayjs(baseDate).month() ? '' : m + 1,
      date: m == dayjs(baseDate).date() ? '' : d
    }
  }
  return null
}

/**
 * 处理较早时间的时间，是否是“较早之前”
 * @param {*} date 被计算时间
 * @param {*} skip 跨度
 * @param {*} unit 减去时间单位
 * @param {*} particle 计算精确颗粒度 ‘month’ ‘year’...
 * @returns
 */
const isRoughAgo = (date, skip, unit, particle = 'day') => {
  let roughAgoTime = dayjs().subtract(skip, unit)
  return date.isBefore(roughAgoTime, particle)
}

const relativeTimeFormat = (
  time,
  pattern = 'M月D日 HH:mm:ss',
  { isRough = false } = {}
) => {
  let start = dayjs(time)
  let end = dayjs()
  if (!start.isValid()) return ''
  const diff = end.diff(start, 'second')
  if (diff < 3) {
    return '刚刚'
  }
  if (diff < 60) {
    return diff + '秒前'
  }
  if (diff < 60 * 60) {
    return parseInt(diff / 60) + '分钟前'
  }
  if (diff < 60 * 60 * 24) {
    return parseInt(diff / (60 * 60)) + '小时前'
  }
  if (diff < 60 * 60 * 24 * 7) {
    return parseInt(diff / (60 * 60 * 24)) + '天前'
  }

  if (isRough) {
    if (isRoughAgo(start, 180, 'day')) {
      return '较早以前'
    }
  }

  return start.year() === end.year()
    ? start.format(pattern)
    : start.format(`YYYY年${pattern}`)
}

// 相对年的展示时间（判断日期是否省略“年”）
const relativeYearFormat = (date, pattern = 'M月D日') => {
  let start = dayjs(date)
  let end = dayjs()
  if (!start.isValid()) return ''

  return start.year() === end.year()
    ? start.format(pattern)
    : start.format(`YYYY年${pattern}`)
}

export default {
  dateRangeToTimeRange,
  getAddRange,
  formateDateRange,
  formateMonthRange,
  formatePeriodRange,
  relativeTimeFormat,
  relativeYearFormat,
  isRoughAgo
}
